import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { ref } from '../../adapter-vue';
import ConversationList from './conversation-list/index.vue';
import ConversationHeader from './conversation-header/index.vue';
import ConversationNetwork from './conversation-network/index.vue';

const LAST_CONVERSATION_ID_KEY = 'gx_chat_conversation_id';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: [
  'handleSwitchConversation',
  'saveAtConversationList',
  'clearChatInput',
  'saveAllConversationList',
],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const totalUnreadCount = ref(0);
const headerRef = ref<typeof ConversationHeader>();
const isShowConversationHeader = ref<boolean>(true);
TUIStore.watch(StoreName.CONV, {
  totalUnreadCount: (count: number) => {
    totalUnreadCount.value = count;
  },
});

TUIStore.watch(StoreName.CUSTOM, {
  isShowConversationHeader: (showStatus: boolean) => {
    isShowConversationHeader.value = showStatus !== false;
  },
});
const saveAllConversationList = (conversationList: any) => {
  emits('saveAllConversationList', conversationList);
};
const handleSwitchConversation = (
  conversationID: string,
  conversationList: any
) => {
  sessionStorage.setItem(LAST_CONVERSATION_ID_KEY, conversationID);
  emits('clearChatInput');
  emits('saveAtConversationList', conversationList);
  emits('handleSwitchConversation', conversationID);
};

const handleClickConv = () => {
  headerRef?.value?.closeChildren();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tui-conversation",
    onClick: handleClickConv
  }, [
    _createVNode(ConversationNetwork),
    _createVNode(ConversationList, {
      onHandleSwitchConversation: handleSwitchConversation,
      onSaveAllConversationList: saveAllConversationList
    })
  ]))
}
}

})